import { Footnote12Description } from "@/components/typography/Footnote12Description";
import { ItemDetailDto } from "@/types/dto/item-detail-dto";
import { TableHeader } from "@/types/table-header";
import { Table, TextInput } from "flowbite-react";
import validator from "validator";
import { CustomCell } from "../CustomCell";
import { ItemSelectedDiscountsTableRow } from "./ItemSelectedDiscountsTableRow";

interface Props {
  selectedItems: ItemDetailDto[];
  newDiscountRate: number;
  updateNewDiscountRate: (newDiscountRate: number) => void;
  handleDeleteFromSelectedItems: (id: number) => void;
  handleDeleteAllFromSelectedItems: () => void;
}

const headers: TableHeader[] = [
  { title: "상품명", width: "w-[861px]" },
  { title: "모델명", width: "w-[160px]" },
  { title: "카테고리", width: "w-[100px]" },
  { title: "원가", width: "w-[100px]" },
  { title: "현재 할인율", width: "w-[100px]" },
  { title: "변경 할인율", width: "w-[171px]" },
  { title: "변경된 판매가", width: "w-[100px]" },
];

export const ItemSelectedDiscountsTable: React.FC<Props> = ({
  selectedItems,
  handleDeleteFromSelectedItems,
  handleDeleteAllFromSelectedItems,
  newDiscountRate,
  updateNewDiscountRate,
}) => {
  const handleNewDiscountRateChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newRate = event.target.value.replace("%", "");
    if (!validator.isNumeric(newRate)) {
      return;
    }
    updateNewDiscountRate(Number(newRate));
  };

  return (
    <div className="h-[354px] w-[1648px] overflow-x-auto rounded-lg border bg-white">
      <Table>
        <Table.Head>
          {headers.map((header) => (
            <Table.HeadCell
              key={header.title}
              className={header.width + " h-[52px] p-0 border-b"}
            >
              <CustomCell className="flex items-center">
                <Footnote12Description className="text-semantic-text-secondary">
                  {header.title}
                </Footnote12Description>
                {header.title === "변경 할인율" && (
                  <TextInput
                    className="w-[80px] ml-[4px]"
                    id="price"
                    type="text"
                    sizing="sm"
                    value={`${newDiscountRate}%`}
                    onChange={handleNewDiscountRateChange}
                  />
                )}
              </CustomCell>
            </Table.HeadCell>
          ))}
          <Table.HeadCell
            className="w-[56px] border-b"
            // onClick={handleDeleteAllFromSelectedItems}
          >
            <CustomCell className="flex items-center">
              <Footnote12Description className="text-semantic-text-secondary">
                삭제
              </Footnote12Description>
            </CustomCell>
          </Table.HeadCell>
        </Table.Head>
        <Table.Body className="divide-y">
          {selectedItems.map((selectedItem) => (
            <ItemSelectedDiscountsTableRow
              key={selectedItem.id}
              item={selectedItem}
              newDiscountRate={newDiscountRate}
              handleDeleteFromSelectedItems={handleDeleteFromSelectedItems}
            />
          ))}
        </Table.Body>
      </Table>
    </div>
  );
};
